export enum PreFlightPolicy {
  DayCalendarFullAccess = 'Pre-Timeline.X',
  DayCalendarReadOnly = 'Pre-Timeline.RO',
  MonthlyCalendarFullAccess = 'Pre-MonthlyCalendar.X',
  MonthlyCalendarReadOnly = 'Pre-MonthlyCalendar.RO',
  CalendarNotesFullAccess = 'Pre-CalendarNotes.X',
  CalendarNotesReadOnly = 'Pre-CalendarNotes.RO',
  StaffEventScheduleFullAccess = 'Pre-StaffEventSchedule.X',
  StaffEventScheduleReadOnly = 'Pre-StaffEventSchedule.RO',
  AircraftEventScheduleFullAccess = 'Pre-AircraftEventSchedule.X',
  AircraftEventScheduleReadOnly = 'Pre-AircraftEventSchedule.RO',
  TripBuilderFullAccess = 'Pre-TripBuilder.X',
  TripBuilderReadOnly = 'Pre-TripBuilder.RO',
  AcknowledgementFullAccess = 'Pre-Acknowledgements.X',
  AcknowledgementReadOnly = 'Pre-Acknowledgements.RO',
  WeeklyCalendarFullAccess = 'Pre-WeeklyCalendar.X',
  WeeklyCalendarReadOnly = 'Pre-WeeklyCalendar.RO',
  UnlockTrip = 'Pre-UnlockTrip.X',
  FuelVendorUploadFullAccess = 'Pre-FuelVendorUpload.X',
  FuelVendorUploadReadonly = 'Pre-FuelVendorUpload.RO'
}

export enum PostFlightPolicy {
  TimeCycleAdjustmentsFullAccess = 'Post-TimeCycleAdjustment.X',
  TimeCycleAdjustmentsReadOnly = 'Post-TimeCycleAdjustment.RO',
  CampActionsFullAccess = 'Post-CampActions.X',
  CampActionsReadOnly = 'Post-CampActions.RO',
  ExpenseCaptureFullAccess = 'Post-ExpenseCapture.X',
  ExpenseCaptureReadOnly = 'Post-ExpenseCapture.RO',
  FlightLogFullAccess = 'Post-FlightLog.X',
  FlightLogReadOnly = 'Post-FlightLog.RO',
  LegUnVerificationsFullAccess = 'Post-LegUnVerifications.X',
  LegUnVerificationsReadOnly = 'Post-LegUnVerifications.RO',
  LegVerificationsFullAccess = 'Post-LegVerifications.X',
  LegVerificationsReadOnly = 'Post-LegVerifications.RO',
  PilotLogbookFullAccess = 'Post-PilotLogbook.X',
  PilotLogbookReadOnly = 'Post-PilotLogbook.RO',
  ReportsFullAccess = 'Post-Reports.X',
  ReportsReadOnly = 'Post-Reports.RO',
  SiflFullAccess = 'Post-Sifl.X',
  SiflReadOnly = 'Post-Sifl.RO',
  FleetTripLegFullAccess = 'Post-FleetTripLeg.X',
  FleetTripLegReadOnly = 'Post-FleetTripLeg.RO',
  TripUnVerificationsFullAccess = 'Post-TripUnVerifications.X',
  TripUnVerificationsReadOnly = 'Post-TripUnVerifications.RO',
  TripVerificationsFullAccess = 'Post-TripVerifications.X',
  TripVerificationsReadOnly = 'Post-TripVerifications.RO',
  Dashboard = 'Post-Dashboard.X'
}

export enum ProfilePolicy {
  AircraftProfileFullAccess = 'Prof-AircraftProfile.X',
  AircraftProfileReadOnly = 'Prof-AircraftProfile.RO',
  AirportProfileFullAccess = 'Prof-AirportProfile.X',
  AirportProfileReadOnly = 'Prof-AirportProfile.RO',
  ChecklistProfileFullAccess = 'Prof-ChecklistProfile.X',
  ChecklistProfileReadOnly = 'Prof-ChecklistProfile.RO',
  CompanyProfileFullAccess = 'Prof-CompanyProfile.X',
  CompanyProfileReadOnly = 'Prof-CompanyProfile.RO',
  CurrencyTrainingEventsFullAccess = 'Prof-CurrencyTrainingEvents.X',
  CurrencyTrainingEventsReadOnly = 'Prof-CurrencyTrainingEvents.RO',
  PersonProfileFullAccess = 'Prof-PersonProfile.X',
  PersonProfileReadOnly = 'Prof-PersonProfile.RO',
  UserManagementFullAccess = 'Prof-UserManagement.X',
  UserManagementReadOnly = 'Prof-UserManagement.RO',
  OrganizationViewFullAccess = 'Prof-OrganizationView.X',
  OrganizationViewReadOnly = 'Prof-OrganizationView.RO',
  AirportNotesFullAccess = 'Prof-AirportNotes.X',
  AirportNotesReadOnly = 'Prof-AirportNotes.RO',
  IntegrationManagementFullAccess = 'Prof-IntegrationManagement.X',
  IntegrationManagementReadOnly = 'Prof-IntegrationManagement.RO',
  ESignatureFullAccess = 'Prof-ESignature.X',
  ESignatureReadOnly = 'Prof-ESignature.RO'
}

export enum AdminPolicy {
  HistoricalUploadFullAccess = 'Admin-HistoricalUpload.X',
  HistoricalUploadReadOnly = 'Admin-HistoricalUpload.RO'
}

export enum BetaPolicy {
  ReportsReadOnly = 'Beta-Reports.RO'
}

export type PolicyType =
  | PreFlightPolicy
  | PostFlightPolicy
  | ProfilePolicy
  | AdminPolicy
  | BetaPolicy;
